import {Auditable} from "./auditable.model";
import {Tenant} from "./tenant.model";

/**
 * User role used on api
 */
export enum UserType {
  CustomerAdmin = 'CustomerAdmin',
  TenantAdmin = 'TenantAdmin',
  Reviewer = 'Reviewer'
}

/**
 * Status code used on api
 */
export enum UserStatus {
  Active = 'Active',
  Pending = 'Pending',
  Inactive = 'Inactive',
  Removed = 'Removed'
}

/**
 * Reason code used on api
 */
export enum UserReason {
  None  = 'N',
  Fraud = 'F',
  System = 'S'
}

export class User extends Auditable<UserStatus> {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  typeCd: UserType;
  reasonCd: UserReason;
  tenants: Tenant[];

  /** First name and Last name */
  get fullName(): string {
    if (this.firstName || this.lastName) {
      return `${this.firstName ?? ''} ${this.lastName ?? ''}`;
    } else {
      return '--'
    }
  }

  /** Gets user role formatted */
  get typeText(): string {
    switch (this.typeCd) {
      case UserType.CustomerAdmin:
        return 'Admin';
      case UserType.TenantAdmin:
        return 'User';
        case UserType.Reviewer:
          return 'Reviewer';
    }
  }

  constructor(user?: User) {
    super(user);
  }
}
